import configureStore from './configureStore';

export const { store, persistor } = configureStore();

export function fromStore(selector) {
  const state = store.getState();
  return selector(state);
}
